import {Flex, Tag, theme, Typography} from 'antd';
import React from 'react';
import {format, isDate} from 'date-fns';
import {useData} from 'Context/DataContext';
import {DATE_FORMAT} from 'Utils/constants/DateFormat';
import {TRANSACTIONS} from 'Pages/Tabs/Transactions/transactionConstants';

const {Text} = Typography;

interface IProps {
  item?: any;
  toggleView?: any;
  handleItem?: any;
  disabled?: boolean;
  showRefulfill?: boolean;
}

// Free-form transaction/offer status — pragmatic keyword heuristic for the
// badge color (same approach used for SR/member status badges elsewhere).
const statusTagColor = (status: string): string => {
  const s = (status || '').toLowerCase();
  if (['reverse', 'cancel', 'fail', 'declin', 'expire'].some((k) => s.includes(k))) return 'error';
  if (['pending', 'process', 'hold'].some((k) => s.includes(k))) return 'warning';
  if (['complet', 'success', 'redeem', 'delivered', 'active'].some((k) => s.includes(k))) {
    return 'success';
  }
  return 'default';
};

// `.list-card` pattern from the AST Console Revamp mockup: a single-line
// title, one compact meta line, and a status badge on the right — replaces
// the previous multi-row/multi-column verbose card.
const TableItemCard: React.FC<IProps> = (props) => {
  const {item, toggleView = null, handleItem = null, disabled = false} = props;
  const {activeTab} = useData();
  const {token}: any = theme.useToken();

  const handleSelection = () => {
    if (disabled) return;
    toggleView();
    handleItem(item);
  };

  const expiryLabel =
    activeTab === 1
      ? TRANSACTIONS.card_field_map.offerEndDate
      : TRANSACTIONS.card_field_map.expiryDate;

  const metaParts = [
    item.claimDate &&
      isDate(new Date(item.claimDate)) &&
      `${TRANSACTIONS.card_field_map.claimDate} ${format(
        new Date(item.claimDate),
        DATE_FORMAT.dateFormat,
      )}`,
    item.expiryDate &&
      isDate(new Date(item.expiryDate)) &&
      `${expiryLabel} ${format(new Date(item.expiryDate), DATE_FORMAT.dateFormat)}`,
    item.merchantName,
    item.offerType,
  ].filter(Boolean);

  return (
    <Flex
      align="center"
      justify="space-between"
      gap={16}
      onClick={handleSelection}
      style={{
        background: token.colorBgContainer,
        border: `1px solid ${token.colorBorderSecondary}`,
        borderRadius: token.borderRadiusLG,
        padding: '14px 16px',
        cursor: disabled ? 'default' : 'pointer',
        opacity: disabled ? 0.85 : 1,
      }}>
      <Flex vertical gap={4} style={{minWidth: 0}}>
        <Text strong style={{fontSize: 13}}>
          {item.offerTitle}
        </Text>
        <Text style={{fontSize: 12, color: token.colorTextSecondary}} ellipsis>
          {metaParts.join(' · ')}
        </Text>
      </Flex>
      {item.transactionStatus && (
        <Tag color={statusTagColor(item.transactionStatus)} style={{margin: 0, flexShrink: 0}}>
          {item.transactionStatus}
        </Tag>
      )}
    </Flex>
  );
};

export default TableItemCard;
